import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const bomberOriginalWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.moveTo(548, 84) // 左上
  ctx.quadraticCurveTo(605, 203, 634, 322) // 右上
  ctx.quadraticCurveTo(611, 343, 589, 356) // 右下
  ctx.quadraticCurveTo(555, 228, 518, 142) // 左下
  ctx.quadraticCurveTo(548, 84, 548, 84) // 左上
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 斜線上周り
  ctx.moveTo(553, 87) // 左上外
  ctx.quadraticCurveTo(607, 201, 636, 315) // 左下
  ctx.moveTo(557, 86) // 左上内
  ctx.quadraticCurveTo(610, 199, 638, 312) // 右下
  ctx.quadraticCurveTo(689, 272, 688, 272) // 右上
  ctx.quadraticCurveTo(644, 135, 557, 90) // 左上
  // 斜線中周り
  ctx.moveTo(550, 94) // 左上
  ctx.quadraticCurveTo(524, 148, 524, 148) // 左下
  ctx.quadraticCurveTo(562, 240, 591, 349) // 右下
  ctx.quadraticCurveTo(628, 320, 630, 320) // 右上
  ctx.quadraticCurveTo(599, 200, 549, 93) // 左上
  // 斜線中周り_上辺内
  ctx.moveTo(547, 99) // 左上
  ctx.quadraticCurveTo(594, 197, 626, 320) // 左下
  // 斜線中周り_下辺内
  ctx.moveTo(526, 143) // 左上
  ctx.quadraticCurveTo(562, 233, 593, 345) // 左下
  // 斜線下周り
  ctx.moveTo(522, 153) // 左上
  ctx.quadraticCurveTo(505, 194, 489, 254) // 左下
  ctx.quadraticCurveTo(521, 330, 584, 354) // 右下
  ctx.quadraticCurveTo(558, 254, 520, 157) // 左上
  // 斜線下周り_上辺内
  ctx.moveTo(518, 160) // 左上
  ctx.quadraticCurveTo(555, 257, 582, 354) // 右下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  // 上段
  crossLaceOfBomberWeb(ctx, laceColor, 60, -370, 15)
  crossLaceOfBomberWeb(ctx, laceColor, 95, -320, 15)
  crossLaceOfBomberWeb(ctx, laceColor, 130, -275, 15)
  crossLaceOfBomberWeb(ctx, laceColor, 160, -225, 15)
  // 下段
  crossLaceOfBomberWeb(ctx, laceColor, 60, -280, 15)
  crossLaceOfBomberWeb(ctx, laceColor, 95, -230, 15)
  crossLaceOfBomberWeb(ctx, laceColor, 130, -180, 15)
  webKnots(ctx, laceColor, -110, -920, 80, 0.8) // 親指側
  webKnots(ctx, laceColor, -320, -820, 80, 0.8) // 小指側
}

const crossLaceOfBomberWeb = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number, numerator?: number, scaleSize?: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  if (numerator !== undefined && numerator !== 0) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
  }
  if (scaleSize !== undefined) {
    ctx.scale(scaleSize, scaleSize)
  }

  // 左側
  ctx.beginPath()
  ctx.moveTo(510 + x, 319 + y) // 左上
  ctx.quadraticCurveTo(507 + x, 352 + y, 507 + x, 352 + y) // 左下
  ctx.quadraticCurveTo(512 + x, 355 + y, 516 + x, 353 + y) // 右下下
  ctx.quadraticCurveTo(522 + x, 325 + y, 519 + x, 315 + y) // 右上
  ctx.quadraticCurveTo(512 + x, 312 + y, 510 + x, 319 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(511 + x, 319 + y) // 左上
  ctx.quadraticCurveTo(513 + x, 332 + y, 507 + x, 350 + y) // 左下
  ctx.stroke()
  ctx.closePath()

  // 右側
  ctx.beginPath()
  // ctx.strokeStyle = 'blue' // '#383838'
  ctx.moveTo(494 + x, 334 + y) // 左上
  ctx.quadraticCurveTo(494 + x, 338 + y, 496 + x, 343 + y) // 左下
  ctx.quadraticCurveTo(525 + x, 337 + y, 533 + x, 337 + y) // 右下
  ctx.quadraticCurveTo(533 + x, 333 + y, 530 + x, 328 + y) // 右上
  ctx.quadraticCurveTo(510 + x, 328 + y, 494 + x, 334 + y) // 左上
  ctx.fill()
  // // 断面ライン
  ctx.moveTo(496 + x, 343 + y) // 下
  ctx.quadraticCurveTo(521 + x, 334 + y, 533 + x, 337 + y) // 右下
  ctx.stroke()
  ctx.closePath()

  if (numerator !== undefined) {
    ctx.restore()
  }
}
